const customOmit = (obj, keys = []) => {
    const result = {};
    if (keys.length === 0) {
        return { ...obj }; // Return a copy of the original object if no keys are provided
    }
    for (const key in obj) {
        if (!keys.includes(key)) {
            result[key] = obj[key];
        }
    }
    return result;
};

export default customOmit;
